import { SolanaExtension } from '@magic-ext/solana';
import { MagicClientBase } from '../../MagicClientBase.js';

class SolanaMagicClient extends MagicClientBase {
    constructor(props) {
        super({ apiKey: props.apiKey });
        this.rpcUrl = props.rpcUrl;
    }
    getClientConfig() {
        const config = {
            extensions: [
                new SolanaExtension({
                    rpcUrl: this.rpcUrl,
                }),
            ],
        };
        if (this.extensions.length > 0 && config.extensions) {
            config.extensions.push(...this.extensions);
        }
        return config;
    }
}

export { SolanaMagicClient };
